import type { CheckInCustomPageProps } from '../types';
import { InjectionCountInputView } from './InjectionCountInputView';
import { InjectionCountSummaryView } from './InjectionCountSummaryView';
import { useInjectionCountPage } from './useInjectionCountPage';

export const InjectionCountPage = ({
  model,
  context,
}: CheckInCustomPageProps) => {
  const {
    mode,
    dosage,
    displayCount,
    maxCount,
    selected,
    setSelected,
    onSubmit,
    onModify,
    onNext,
  } = useInjectionCountPage(model, context);

  if (mode === 'summary') {
    return (
      <InjectionCountSummaryView
        dosage={dosage}
        displayCount={displayCount}
        maxCount={maxCount}
        onModify={onModify}
        onNext={onNext}
      />
    );
  }

  return (
    <InjectionCountInputView
      selected={selected}
      onSelectedChange={setSelected}
      onSubmit={onSubmit}
    />
  );
};
